<template>
  <div
    class="edit-station edit-station-advanced"
  >
    <div class="edit-station-parameters__column">
      <div>
        <select-element
          :title="'Deep Root Type'"
          :value="computedRootDepth"
          :list="rootDepths"
          :emit-function-named="'setRootDepth'"
          @setRootDepth="setRootDepth"
        />
        <br>
        <input-element
          class="edit-program__top-bar__name"
          :title="'Deep Root'"
          :prefix="getDenominator('centimetre', 'inch', 0)"
          :text="computedActRootDepth"
          :disabled="computedRootDepth === '20'"
          :placeholder="'Description'"
          :emit-function-named="'setActDeepRoot'"
          @setActDeepRoot="setActDeepRoot"
        />
      </div>
      <br>
      <landscape-precipitation-calculator 
        @transfer-landscape="setLandscapeCoefficient"
      />
    </div>
    <div class="edit-station-parameters__column">
      <input-element
        class="edit-program__top-bar__name"
        :name="'Description'"
        :title="'Landscape Coefficient'"
        :text="computedLC"
        :placeholder="'Description'"
        :emit-function-named="'setLandscapeCoefficient'"
        @setLandscapeCoefficient="setLandscapeCoefficient"
      />
      <input-element
        class="edit-program__top-bar__name"
        :name="'Description'"
        :prefix="'Percent'"
        :title="'MAD'"
        :text="computedMAD"
        :placeholder="'Description'"
        :emit-function-named="'setMad'"
        @setMad="setMad"
      />
    </div>
  </div>
</template>

<script>
import{SocketHandler, LifeCycle, MicroService, UnitSystem} from'@/assets/javascript/mixins/Mixins'
import {lowerCaseObject} from '@/assets/javascript/utilities'

import SelectElement from'@/components/elements/SelectElementReactive.vue'
import InputElement from'@/components/elements/InputElement.vue'

import LandscapeCoefficientCalculatorElement from'@/components/elements/LandscapeCoefficientCalculatorElement'

export default {
  name: 'EditStationAdvanced',
  components:
  {
    'input-element': InputElement,
    'select-element': SelectElement,
    'landscape-precipitation-calculator': LandscapeCoefficientCalculatorElement
  },
  mixins: [SocketHandler, LifeCycle, MicroService, UnitSystem],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    station: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return {
      actRootDepth: this.station.actRootDepth,
      plantTypes: null,
      rootDepths: [{
        value: '20',
        label: 'Default'
      },{
        value: '40',
        label: 'Custom'
      }]
    }
  },
  computed: {
    computedRootDepth() {
      return this.findValueInArray(this.rootDepths, this.station.rootDepth)
    },
    computedActRootDepth() {
      let rtn = 0
      if(!(this.plantTypes && this.station.plantType)) {
        return null
      }

      if(this.station.rootDepth === '20') {
        const type = this.plantTypes.find(plantType => this.station.plantType === plantType.id)
        rtn = type ? parseInt(type.rootdepth | type.rootDepth) : '0'
      } else {
        rtn = this.actRootDepth
      }

      return this.convertUnits(rtn / 100, 'in', 'cm')
    },
    computedLC() {
      return this.station.lc ? this.station.lc / 100 : '0'
    },
    computedMAD() {
      return this.station.mad ? this.station.mad : '0'
    },
  },
  created() {
    this.request('api/auth/decoders/planttypes', 'plantTypes')
  },
  methods: {
    findValueInArray: (ary, item) => {
      if(!(ary && ary.length && item)) return null
  
      const obj = ary.find(cur => cur.value === item)
      
      return obj ? obj.value : null
    },
    updateStation(fields) {
      this.SocketMessageSend(
        Object.assign({}, {
          Category: 'Stations',
          Type: 'StationData',
          Oper: 'Upd',
          Seq: this.station.decId
        },
        lowerCaseObject(fields))
      )
      Object.keys(fields).forEach(key=> this.$set(this.station, key, '' +  fields[key])) // @TODO: Should be done with return data when ready
    },
    setActDeepRoot(val) {
      console.debug('updating')
      this.updateStation({actRootDepth: this.convertUnits(val * 100, 'cm', 'in')})
    },
    setRootDepth(deepRootObj) {
      this.updateStation({rootDepth: deepRootObj.value})
      if(deepRootObj.value === '20') {
        this.$nextTick(() => this.setActDeepRoot(this.computedActRootDepth))
      }
    },
    setMad(val) {
      this.updateStation({mad: val})
    },
    setLandscapeCoefficient(val) {
      if(isNaN(val)) 
        val = val.target.value
      this.updateStation({lc: Math.round(val * 100)})
    },
    request(path, pointerString) {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: path
      })
      .then((response) => {
        if(response.data && response.data.length) {
          response.data.pop()
          this.$set(this, pointerString, response.data)
        } else {
          console.error(response)
        }
      }).catch(console.error)
    }
  }
}
</script>